import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'resend verification email',
    defaultMessage: 'Resend Verification Email',
    id: 'p7QDuP',
  },
  emailSentSuccess: {
    description: 'verification email sent successfully',
    defaultMessage: 'Verification Email Successfully Sent',
    id: 'enOuT7',
  },
  sendButtonText: {
    description: 'resend verification email send button',
    defaultMessage: 'Send',
    id: 'Zjssmr',
  },
  emailInputLabel: {
    description: 'resend verification email input label',
    defaultMessage: 'Email',
    id: 'SWX/zR',
  },
  returnToLogin: {
    description: 'resend verification email return to login',
    defaultMessage: 'Return to Log In',
    id: 'wmEz13',
  },
  verifyErrorMessage: {
    description: 'resend verification email error',
    defaultMessage: 'Matching user not found for this email.',
    id: '83XjEH',
  },
});

export default messages;
